import {selectNavOption} from "./nav_option_helpers";
import {clearAuxResourceName, clearAuxResourceUrl} from "./commit_helpers";

export function closeAux(sm, auxHeaderCloser) {
    clearAuxResourceUrl(sm);
    clearAuxResourceName(sm);

    // If we have a previous nav option stored then select it
    if (sm.state['prevNavOption'] !== null) {
        selectNavOption(sm, sm.state['prevNavOption']);
    }

}

